import React, { useState, useCallback, useRef, useEffect } from 'react';

import DataGrid, { Selection, RowDragging, Column, Editing, Scrolling, Paging, Toolbar, Item, MasterDetail, Export, Summary, TotalItem } from 'devextreme-react/data-grid';
import LoadPanel from 'devextreme-react/load-panel';
import DropDownButton, { DropDownButtonTypes } from 'devextreme-react/drop-down-button';
import { withLoadPanel } from '../../../utils/withLoadPanel';
import TextBox from 'devextreme-react/text-box';
import './CardResults.scss';

import { checkPermission } from '../../../permissions';
import { EditCellTimeComponent, EditCellTimeRender, editCellTimeRender, TimeBox, TimeBoxBold } from '../../utils/time-box/TimeBox';
import { Button, NumberBox } from 'devextreme-react';
import { PerformanceCell } from '../../utils/performance-cell/PerformanceCell';
import { useScreenSize } from '../../../utils/media-query';
import { COMPETITION_STATUS_LIST, exportFormats } from '../../../shared/constants';
import { ResultDetails } from '../result-details/ResultDetails';
import { onExporting } from '../../../utils/exporter';
import { useNavigate } from 'react-router-dom';
import { FALSE } from 'sass';
import { getApiToken } from '../../../utils/authUtils.js';
import axios from 'axios';
import { useMsal } from "@azure/msal-react";
import { openPDFOnDevice } from '../../../utils/pdfUtils';
import { createStore } from 'devextreme-aspnet-data-nojquery';


const Grid = ({ results, competitionId, traininggroups }) => {
    const { instance, accounts } = useMsal();
    const [gridDataSource, setGridDataSource] = useState(null);
    const [filterStatusList, setfilterStatusList] = useState(traininggroups?.length > 0 ? ['alle', ...traininggroups.map((group) => group.groupname)] : ["alle"]);
    const [pdfLoading, setPdfLoading] = useState(false);

    const dropDownOptions = { width: 'auto' };
    const handleInitNewRow = (e) => {
        e.data.competitionId = competitionId;
    };
    const gridRef = useRef(null);
    var traininggroupName = JSON.parse(localStorage.getItem('traininggroupName'));
    const [status, setStatus] = useState(traininggroupName != null ? traininggroupName : filterStatusList[0]);
    const navigate = useNavigate();
const GroupCell = options => <div>{options.value}</div>;
    useEffect(() => {
        getApiToken(instance, accounts).then(token => {
            // Initialize filter based on status and competitionId
            let filterParams;
            if (status !== 'alle') {
                filterParams = [`[[\"groupname\",\"${status}\"],\"and\",[\"competitionId\",\"${competitionId}\"]]`];
            } else {
                filterParams = [`[\"competitionId\",\"${competitionId}\"]`];
            }

            setGridDataSource({
                store: createStore({
                    key: 'resultId',
                    loadUrl: `${process.env.REACT_APP_serverEndpoint}/Result/ResultsView`,
                    insertUrl: `${process.env.REACT_APP_serverEndpoint}/Result/InsertResult`,
                    updateUrl: `${process.env.REACT_APP_serverEndpoint}/Result/UpdateResult`,
                    deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Result/DeleteResult`,
                    onBeforeSend: (method, ajaxOptions) => {
                        ajaxOptions.headers = {
                            'Authorization': "Bearer " + token
                        };
                    },
                    loadParams: { filter: filterParams }
                })
            });
        });
    }, [instance, accounts, competitionId, status]);
    const calculateCustomSummary = (options) => {
        if (options.name === 'ResultCount') {
            if (options.summaryProcess === 'start') {
              

                options.totalValue = {pBs: 0, total: 0, performance: 0.00};
              
            }
            if (options.summaryProcess === 'calculate') {
                 var tot =  options.totalValue
                tot.total += 1;
                if (options.value.performance >= 0) {
                    tot.pBs += 1;
                }
                tot.performance = tot.pBs / tot.total;

            }
        }
    };
    const filterByStatus = useCallback((e) => {
        const { item: status } = e;

        getApiToken(instance, accounts).then(token => {
            let filterParams;
            if (status === 'alle') {
                filterParams = [`[\"competitionId\",\"${competitionId}\"]`];
            } else {
                filterParams = [`[[\"groupname\",\"${status}\"],\"and\",[\"competitionId\",\"${competitionId}\"]]`];
            }

            setGridDataSource({
                store: createStore({
                    key: 'resultId',
                    loadUrl: `${process.env.REACT_APP_serverEndpoint}/Result/ResultsView`,
                    insertUrl: `${process.env.REACT_APP_serverEndpoint}/Result/InsertResult`,
                    updateUrl: `${process.env.REACT_APP_serverEndpoint}/Result/UpdateResult`,
                    deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Result/DeleteResult`,
                    onBeforeSend: (method, ajaxOptions) => {
                        ajaxOptions.headers = {
                            'Authorization': "Bearer " + token
                        };
                    },
                    loadParams: { filter: filterParams }
                })
            });
        });

        setStatus(status);
    }, [instance, accounts, competitionId]);
    const onPDFClick = useCallback(async () => {
        try {
            setPdfLoading(true);
            const token = await getApiToken(instance, accounts);
            const response = await axios.get(`${process.env.REACT_APP_serverEndpoint}/Result/ReportResultAsPdf?competitionId=${competitionId}&groupname="${status}"`, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const fileName = `Ergebnisse_${competitionId}.pdf`;

            await openPDFOnDevice(blob, fileName);
        } catch (error) {
            console.error('Error downloading PDF:', error);
        } finally {
            setPdfLoading(false);
        }
    }, [status, competitionId, instance, accounts]);

    const onCellDblClick = useCallback((e) => {

        if (e.rowType == 'data' && e.column.dataField == "competitionname") {
            const competitionId = e.data.competitionId;
            navigate(`/competition/edit/${competitionId}`)
        }
        if (e.rowType == 'group') {
            const athleteId = e.data.items[0]?.athleteId;
            navigate(`/athlete/edit/${athleteId}`)
        }
    }, []);


    return (
        <div className='results-card'>
            <DataGrid
                className='results-grid'
                dataSource={gridDataSource}
                remoteOperations={false}
                width={'100%'}
                height={'calc(100vh - 250px)'}
                onInitNewRow={handleInitNewRow}
                rowAlternationEnabled={true}
                onExporting={onExporting}
                ref={gridRef}
                onCellDblClick={onCellDblClick}
                filterRow={{ visible: true, applyFilter: 'auto' }}
            //  columnAutoWidth={useScreenSize() === 'xs'}
            >
                <Export enabled formats={exportFormats} />
                <Paging enabled={false} />
                <MasterDetail
                    enabled={true}
                    component={ResultDetails}
                />
                <Toolbar>
                    <Item location='after' locateInMenu='auto'>
                        <Button
                            icon='exportpdf'
                            disabled={pdfLoading}
                            onClick={onPDFClick}
                        />
                    </Item>


                    <Item location='after' locateInMenu='auto'>
                        <DropDownButton
                            items={filterStatusList}
                            stylingMode='text'
                            text={status}
                            dropDownOptions={dropDownOptions}
                            useSelectMode
                            onSelectionChanged={filterByStatus}
                            visible={competitionId !== undefined}
                        />
                    </Item>

                </Toolbar>
                <Scrolling mode='virtual' />
                <Editing allowUpdating={checkPermission("result.edit")} allowAdding={false} allowDeleting={checkPermission("result.edit")} />

                <Column
                    groupIndex={competitionId === undefined ? undefined : 0}
                    dataField='athletename'
                    caption='Sportler'
                    width={0}
                    allowEditing={false}
              groupCellRender={GroupCell}
                />

                <Column
                    visible={competitionId === undefined ? true : false}
                    dataField='startdate'
                    caption='Datum'
                    dataType='date'
                    width={100}
                    sortIndex={competitionId === undefined ? 0 : undefined}
                    sortOrder={competitionId === undefined ? 'desc' : undefined}
                    allowEditing={false}
                />
                <Column
                    visible={competitionId === undefined ? true : false}
                    dataField='competitionname'

                    caption='Wettkampf'
                    width={200}
                    allowEditing={false}

                />
                <Column

                    dataField='eventorder'
                    visible={false}
                    sortIndex={competitionId === undefined ? undefined : 0}
                    sortOrder={competitionId === undefined ? undefined : 'asc'}
                    allowEditing={false}
                />

                <Column
                    dataField='number'
                    caption='WettkampfNr'
                    width={50}
                    hidingPriority={5}
                    visible={competitionId === undefined ? false : true}
                    allowEditing={false}
                />
                <Column
                    dataField='name'
                    caption='Strecke'
                    width={80}
                    hidePriority={7}
                    allowEditing={false}
                />
                <Column
                    dataField='swimtime'
                    caption='Zeit'
                    dataType='number'
                    width={80}
                    cellRender={TimeBoxBold}
                    editCellComponent={EditCellTimeComponent}
                    hidingPriority={6}
                />
                <Column
                    dataField='minSwimtime'
                    caption='Bestzeit'
                    cellRender={TimeBox}

                    width={80}
                    hidingPriority={4}
                    allowEditing={false}
                />
                <Column
                    dataField='performance'
                    caption='Perfomance'
                    minWidth={0}
                    width={110}
                    cellRender={PerformanceCell}
                    hidingPriority={3}
                    allowEditing={false}

                />
                <Column
                    dataField='rudolphPoints'
                    caption='Rudolph-Punkte'
                    width={80}
                    hidingPriority={2}

                />
                <Column
                    dataField='waPoints'
                    caption='WA-Punkte'
                    width={80}
                    hidingPriority={1}

                />
                <Column
                    dataField='details'
                    caption='Detail'
                    wordWrapEnabled={true}
                    width={80}
                    hidingPriority={0}
                />
                {competitionId != null ? (<Summary calculateCustomSummary={calculateCustomSummary}>
                    <TotalItem
                        name="ResultCount"
                        summaryType="custom"
                        showInColumn="performance"
                        customizeText={(e) => {
                            return e.value?.pBs + " von " + e.value?.total + " (" + (e.value?.performance?.toFixed(2) * 100) + "%)";
                        }
                        }
                    />
                </Summary>) : null}

            </DataGrid>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                visible={pdfLoading}
                showIndicator={true}
                showPane={true}
                shading={true}
                message="PDF wird erstellt..."
                position={{ of: '.results-card' }}
            />
        </div>
    );
};

const GridWithLoadPanel = withLoadPanel(Grid);

export const CardResults = ({ results, isLoading, competitionId, traininggroups }) => {

    return (
        <div className='card-results'>
            <GridWithLoadPanel
                results={results}
                hasData={!!results}
                loading={isLoading}
                competitionId={competitionId}
                traininggroups={traininggroups}
                panelProps={{
                    container: '.card-results',
                    position: { of: '.card-results' }
                }}
            />
        </div>
    );
};


